var map = {
	"./Aggressive/sectors.json": [
		6715,
		715
	],
	"./Conservative/sectors.json": [
		1326,
		326
	],
	"./PulseCast/sectors.json": [
		7543,
		543
	],
	"./Realistic/sectors.json": [
		2293,
		293
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 7554;
module.exports = webpackAsyncContext;